import { db } from '../../utils/firebase';

export const getAllSponsors = async () => {
  const querySnapshot = await db.collection("sponsors").get();

  const sponsors = [];
  querySnapshot.forEach(doc => {
    const { title, grants } = doc.data();
    sponsors.push({ title, grants });
  });

  sponsors.sort((a, b) => a.order - b.order);

  return sponsors;
}
